<template>
    <div class="message-wrapper">
        <div
            v-if="currentConversationType === TIM.TYPES.CONV_C2C"
            class="c2c-layout"
            :class="messagePosition"
        >
            <!-- 单聊 -->
            <div class="col-1" v-if="showAvatar">
                <!-- 头像 -->
                <Avatar :src="avatar" />
            </div>
            <div class="col-2">
                <!-- 消息主体 -->
                <div class="content-wrapper">
                    <MessageStatusIcon v-if="isMine" :message="message" />
                    <TextElement
                        v-if="message.type === TIM.TYPES.MSG_TEXT"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <ImageElement
                        v-else-if="message.type === TIM.TYPES.MSG_IMAGE"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <SoundElement
                        v-else-if="message.type === TIM.TYPES.MSG_SOUND"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <VideoElement
                        v-else-if="message.type === TIM.TYPES.MSG_VIDEO"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <CustomElement
                        v-else-if="message.type === TIM.TYPES.MSG_CUSTOM"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <FaceElement
                        v-else-if="message.type === TIM.TYPES.MSG_FACE"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    
                </div>
                <MessageFooter v-if="showMessageHeader" :message="message" />
            </div>

        </div>
        <div
            v-if="currentConversationType === TIM.TYPES.CONV_GROUP"
            class="group-layout"
            :class="messagePosition"
        >
            <!-- 群聊 -->
            <!-- 头像 群组没有获取单个头像的接口，暂时无法显示头像-->
            <div class="col-1" v-if="showAvatar" >
                <Avatar class="group-member-avatar" :src="avatar"/>
            </div>
            <div class="col-2">
                <!-- 消息主体 -->
                <MessageHeader v-if="showMessageHeader" :message="message" />
                <div class="content-wrapper">
                    <MessageStatusIcon v-if="isMine" :message="message" />
                    <TextElement
                        v-if="message.type === TIM.TYPES.MSG_TEXT"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <ImageElement
                        v-else-if="message.type === TIM.TYPES.MSG_IMAGE"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <file-element
                        v-else-if="message.type === TIM.TYPES.MSG_FILE"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <SoundElement
                        v-else-if="message.type === TIM.TYPES.MSG_SOUND"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <VideoElement
                        v-else-if="message.type === TIM.TYPES.MSG_VIDEO"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <GroupTipElement
                        v-else-if="message.type===TIM.TYPES.MSG_GRP_TIP"
                        :payload="message.payload"
                    />
                    <CreateGroupElement
                        v-else-if="message.payload.data === 'group_create'"
                        :isMine="isMine"
                        :payload="message.payload"
                    />
                    <CustomElement
                        v-else-if="message.type === TIM.TYPES.MSG_CUSTOM"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    <FaceElement
                        v-else-if="message.type === TIM.TYPES.MSG_FACE"
                        :isMine="isMine"
                        :payload="message.payload"
                        :message="message"
                    />
                    
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import MessageHeader from './message-header'
import MessageFooter from './message-footer'
import Avatar from '../../components/ChatAvatar'
import MessageStatusIcon from './message-status-icon'
import TextElement from './message-elements/text-element'
import ImageElement from './message-elements/image-element'
import FileElement from './message-elements/file-element'
import SoundElement from './message-elements/sound-element'
import VideoElement from './message-elements/video-element'
import CustomElement from './message-elements/custom-element.vue'
import FaceElement from './message-elements/face-element.vue'
import CreateGroupElement from './message-elements/create-group-element.vue'
import GroupTipElement from './message-elements/group-tip-element'
export default {
    name: 'MessageItem',
    props: {
        message: {
            type: Object,
            required: true
        }
    },
    components: {
        MessageHeader,
        MessageFooter,
        Avatar,
        MessageStatusIcon,
        TextElement,
        ImageElement,
        FileElement,
        SoundElement,
        VideoElement,
        CustomElement,
        FaceElement,
        CreateGroupElement,
        GroupTipElement
    },
    computed: {
        ...mapState({
            currentConversation: state => state.currentConversation,           
        }),
        ...mapGetters([
            'user',
        ]),
        isMine() {
            // console.log(this.user, this.currentConversation);
            if (this.message.payload.data === 'group_create') {
                return false
            }
            return this.message.flow === 'out'
        },
        currentConversationType() {
            return this.currentConversation.type
        },
        messagePosition() {
            if (
                ['TIMGroupTipElem', 'TIMGroupSystemNoticeElem'].includes(
                this.message.type
                )
            ) {
                return 'position-center'
            }
            if (this.message.isRevoked) { // 撤回消息
                return 'position-center'
            }
            if (this.message.payload.data === 'group_create') {
                return 'position-center'
            }
            if (this.isMine) {
                return 'position-right'
            } else {
                return 'position-left'
            }
        },
        showAvatar() {
            if (this.currentConversation.type === 'C2C' && !this.message.isRevoked) { // C2C且没有撤回的消息
                return true
            } else if (this.currentConversation.type === 'GROUP' && !this.message.isRevoked) { // group且没有撤回的消息
                if (this.message.payload.data === 'group_create') {
                    return false
                }
                return this.message.type !== this.TIM.TYPES.MSG_GRP_TIP
            }
            return false
        },
        avatar() {
            if (this.currentConversation.type === 'C2C') {
                return this.isMine
                ? this.user.avatar
                : this.currentConversation.userProfile.avatar
            } else if (this.currentConversation.type === 'GROUP') {
                return this.isMine
                ? this.user.avatar
                : this.message.avatar
            } else {
                return ''
            }
        },
        showMessageHeader() {
            if (
                ['TIMGroupTipElem', 'TIMGroupSystemNoticeElem'].includes(
                this.message.type
                )
            ) {
                return false
            }
            if (this.message.isRevoked) { // 撤回消息
                return false
            }
            if (this.message.payload.data === 'group_create') {
                return false
            }
            return true
        }
    },
}
</script>

<style>
.message-wrapper {
    margin: 20px 0;
}

.c2c-layout, .group-layout, .message-wrapper .content-wrapper, .system-layout {
    display: flex;
}

.c2c-layout.position-center, .group-layout.position-center, .system-layout.position-center {
    justify-content: center;
}

.c2c-layout.position-left .col-2, .group-layout.position-left .col-2, .system-layout.position-left .col-2 {
    align-items: flex-start;
}

.c2c-layout.position-right .col-2, .group-layout.position-right .col-2, .system-layout.position-right .col-2 {
    align-items: flex-end;
}

.c2c-layout.position-right, .group-layout.position-right, .system-layout.position-right {
    flex-direction: row-reverse;
}

.c2c-layout .col-2, .group-layout .col-2, .system-layout .col-2 {
    display: flex;
    flex-direction: column;
}

.c2c-layout .col-2 .base {
    margin-top: 3px;
}

.message-wrapper .content-wrapper {
    align-items: center;
}

.chat-bubble {
    position: relative;
}

.chat-bubble .el-dropdown {
    vertical-align: top;
}

.chat-bubble .message-received {
    background-color: #fff;
    margin-left: 15px;
    border-radius: 4px;
}

.chat-bubble .message-send {
    background-color: #e5f3fd;
    margin-right: 15px;
    border-radius: 4px;
}

.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 10px 0;
    margin: 5px 0;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.chat-bubble .message-received:before {
    position: absolute;
    left: -9px;
    top: 13px;
    content: "";
    border: 5px solid rgba(0,0,0,0);
    height: 0;
    width: 0;
    z-index: 1;
    border-right-color: #fff;
    border-top-color: #fff;
}

.chat-bubble .message-send:before {
    position: absolute;
    right: -8px;
    top: 13px;
    border: 5px solid rgba(0,0,0,0);
    height: 0;
    width: 0;
    content: "";
    z-index: 1;
    border-left-color: #e5f3fd;
    border-top-color: #e5f3fd;
}

.chat-bubble .message-content {
    outline: none;
    font-size: 14px;
    position: relative;
    max-width: 350px;
    word-wrap: break-word;
    word-break: break-all;
    padding: 10px;
    box-shadow: 0 5px 10px 0 rgba(0,0,0,.1);
}
</style>